import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"   viewBox="0 0 1081.000000 1081.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1081.000000) scale(0.100000,-0.100000)">


<path d="M3235 6236 c-94 -42 -140 -165 -96 -261 65 -144 269 -157 352 -22 58
96 20 226 -82 277 -45 23 -129 26 -174 6z"/>
<path d="M2930 6128 c-66 -25 -145 -102 -180 -173 -20 -41 -24 -65 -25 -140
l0 -90 164 -483 c185 -544 156 -494 260 -445 114 54 181 159 189 293 4 75 3
76 -162 565 -91 270 -166 491 -166 493 0 6 -30 -1 -80 -20z"/>
<path d="M2476 5975 c-144 -58 -226 -177 -226 -326 0 -48 28 -141 165 -550 91
-271 165 -494 165 -495 0 -6 65 17 105 36 55 27 130 107 157 168 12 27 23 77
26 118 4 68 1 80 -112 420 -64 192 -140 417 -169 501 l-53 152 -58 -24z"/>
<path d="M2148 4930 c-97 -53 -135 -184 -79 -277 40 -65 133 -110 202 -97 177
34 227 246 86 358 -33 26 -48 31 -105 33 -52 3 -75 -1 -104 -17z"/>
</g>
</svg>


    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
